<template>
    <FKAccordion :id="`surveys-${survey.id}-${instance.id}`" v-for="instance in responses" class="mb-2"
        :key="instance.id">
        <template v-slot:title>
            <span class="small fs-16">
                <span class="fw-bold">
                    {{ instance.date }}
                </span>
                <span class="text-muted">
                    &nbsp;-
                    {{ formatTime(instance.created_at) }}
                </span>
                <span v-if="instance.created_by_role === role.caregiver" class="text-muted">
                    &nbsp;-
                    {{ $t(`feature.roles.$type.${instance.created_by_role}`) }}
                </span>
            </span>
        </template>
        <ul class="ps-0 mb-0 list-unstyled" :data-response-id="instance.id" >
            <li class="d-flex p-2" v-for="answer in instance.answers" :key="answer.id" :data-survey-id="survey.id" :data-step-id="answer.step_id" :data-answer-id="answer.id" :data-answer="answer.value_type !== 'PDI' ? answer.value : 'PDI'">
                <div class="d-flex justify-content-between flex-grow-1  gap-3">
                    <!-- QUESTION -->
                    <span class="fs-md-15 fw-medium text-muted position-relative survey-question"
                        v-html="$s.getStep(answer.step_id)?.title"></span>
                    <!-- ANSWER -->
                    <span class="text-muted fw-medium survey-answer">
                        <PDIView v-if="$s.getStep(answer.step_id)?.type === 'PDI'" :step_id="answer.step_id"
                            :points="($s.getAnswer(answer.step_id, instance) as PDIAnswer)" />
                        <template v-else>
                            {{ $s.getAnswer(answer.step_id, instance) }}
                        </template>
                    </span>
                </div>
            </li>
        </ul>
    </FKAccordion>
</template>
<style lang="scss">
    .survey-answer {
        min-width: fit-content;
    }
</style>
<script lang="ts">
import API from '@/services/api/api.service';
import { Survey, SurveyResponse, SurveyStep, SurveyStepRepresentationType, SurveyStepType } from '@/utils/models/survey.model';
import DateFormatUtils from "@/utils/methods/date_formats";
import { PropType, defineComponent } from 'vue';
import { CLIENT, Environment } from '@/utils/const/env';
import FKAccordion from '../FKAccordion.vue';
import { PDIAnswer, SurveyUtils } from '@/utils/methods/survey_utils';
import PDIView from './utils/PDIView.vue';
import { Role } from '@/utils/models/user.model';

export default defineComponent({
    name: 'SurveyResponses',
    props: {
        survey: {
            type: Object as PropType<Survey>,
            required: true
        },
        responses: {
            type: Object as PropType<SurveyResponse[]>,
            required: false
        }
    },
    data: function () {
        return {
            responses_data: undefined,
            patient_id: this.$route.params.id,
        } as {
            responses_data?: SurveyResponse[];
            patient_id: string;
        }
    },
    computed: {
        instances(): SurveyResponse[] | undefined {
            return this.responses ?? this.responses_data;
        },
        role() {
            return Role;
        },
        stepType() { return SurveyStepType },
        env(): Environment { return CLIENT },
        $s(): SurveyUtils {
            return new SurveyUtils(this.survey, this.responses ?? []);
        }
    },
    methods: {
        questions(survey_id: number): SurveyStep[] {
            return this.survey.steps.filter((step) => step.type !== SurveyStepType.description && step.type !== SurveyStepType.finalize);
        },
        getSurveyAnswers() {
            this.responses_data = undefined;
            API.getSurveyAnswers({ survey_id: this.survey.id, patient_id: this.patient_id }).then((response) => {
                this.responses_data = response.data.data ?? [];
            }).catch((error) => {
                console.error(error);
                this.responses_data = [];
            });

        },
        formatTime(date: Date) {
            return DateFormatUtils.HHmm(date);
        }
    },
    mounted() {
        if (this.responses === undefined) {
            this.getSurveyAnswers();
        }
    },
    components: {
        FKAccordion,
        PDIView,
    }
})

</script>
